import LaravelEcho from 'laravel-echo'

window.Pusher = require('pusher-js')

const pusherKey = document.head.querySelector('meta[name="pusher-key"]')
const cluster = document.head.querySelector('meta[name="pusher-cluster"]')
const broadcastDriver = document.head.querySelector('meta[name="broadcast-driver"]')

let echo = {}

if (pusherKey != null) {
  echo = new LaravelEcho({
    broadcaster: broadcastDriver.content,
    key: pusherKey.content,
    cluster: cluster.content,
    encrypted: true,
    disableStats: true
  })
  console.log('echo initiated')
}

export const Echo = echo
